export const Digits4Schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، CRM ابری، خط تلفن اینترنتی، پنل پیامکی، فکس آنلاین و خطوط ویژه مخابراتی.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-82800000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/4-digit-line/#webpage",
      "url": "https://navatel.ir/products/4-digit-line/",
      "name": "خط تلفن ۴ رقمی مخابرات | شماره‌ای کوتاه و به‌یادماندنی برای برند شما",
      "description": "خط ۴ رقمی مخابرات نواتل، کوتاه‌ترین و حرفه‌ای‌ترین شماره تماس برای سازمان‌های بزرگ است. این خطوط استانی بوده، مختص مشتریان حقوقی هستند و فقط با پیش‌شماره استان تهران ارائه می‌شوند.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/4-digit-line/#service"
      },
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/4-digit-line/#breadcrumb"
      }
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/4-digit-line/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "خط تلفن ۴ رقمی مخابرات",
          "item": "https://navatel.ir/products/4-digit-line/"
        }
      ]
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/products/4-digit-line/#service",
      "name": "خط تلفن ۴ رقمی مخابرات نواتل",
      "alternateName": "شماره تماس اختصاصی ۴ رقمی سازمانی",
      "serviceType": "خط تلفن اختصاصی ۴ رقمی مخابرات (وساطت خرید از مخابرات ایران)",
      "description": "خط تلفن ۴ رقمی مخابرات، کوتاه‌ترین و حرفه‌ای‌ترین شماره تماس برای سازمان‌های بزرگ است که به برندسازی، تمایز از رقبا و اثربخشی بالاتر کمپین‌های تبلیغاتی کمک می‌کند. نواتل به‌عنوان واسطه، فرآیند ثبت، تأیید مدارک از مخابرات ایران و تحویل این خطوط را انجام می‌دهد. این خطوط استانی بوده و فقط با پیش‌شماره استان تهران ارائه می‌شوند و مختص اشخاص حقوقی (شرکت‌ها و سازمان‌ها) هستند. خطوط به‌صورت پیش‌فرض یک‌طرفه (فقط دریافت تماس) هستند و امکان تبدیل به دوطرفه با افزودن رقم صفر و درخواست و تأیید جداگانه از مخابرات وجود دارد.",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "areaServed": {
        "@type": "City",
        "name": "تهران",
        "sameAs": "https://www.wikidata.org/wiki/Q3616"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "اشخاص حقوقی (شرکت‌ها و سازمان‌ها) - بدون امکان ثبت برای اشخاص حقیقی"
      },
      "url": "https://navatel.ir/products/4-digit-line/",
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://navatel.ir/products/4-digit-line/",
        "availability": "https://schema.org/InStock",
        "priceSpecification": {
          "@type": "PriceSpecification",
          "description": "قیمت خط ۴ رقمی بر اساس شماره انتخابی متغیر است و نیازمند استعلام از کارشناسان نواتل می‌باشد."
        }
      },
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "مدرک ۱ - کارت ملی",
          "value": "تصویر پشت و رو کارت ملی صاحبین امضای مجاز"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۲ - شناسنامه",
          "value": "تصویر صفحه اول و صفحه تغییرات شناسنامه صاحبین امضای مجاز"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۳ - آگهی تاسیس",
          "value": "تصویر آگهی تاسیس شرکت"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۴ - روزنامه رسمی",
          "value": "تصویر روزنامه رسمی شرکت شامل آخرین تغییرات"
        },
        {
          "@type": "PropertyValue",
          "name": "مدرک ۵ - سند محل",
          "value": "سند مالکیت یا اجاره‌نامه شرکت"
        },
        {
          "@type": "PropertyValue",
          "name": "نوع خط",
          "value": "پیش‌فرض یک‌طرفه؛ قابل تبدیل به دوطرفه با تأیید مخابرات"
        }
      ]
    },
    {
      "@type": "HowTo",
      "@id": "https://navatel.ir/products/4-digit-line/#howto",
      "name": "مراحل دریافت خط ۴ رقمی از نواتل",
      "description": "فرآیند چهار مرحله‌ای دریافت خط تلفن ۴ رقمی مخابرات از نواتل، از مشاوره اولیه تا تحویل و فعال‌سازی خط.",
      "about": {
        "@id": "https://navatel.ir/products/4-digit-line/#service"
      },
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "مشاوره و انتخاب شماره",
          "text": "برای بررسی شماره‌های موجود، با کارشناسان نواتل تماس بگیرید."
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "ارسال مدارک",
          "text": "مدارک حقوقی شرکت را به همراه نامه‌ی درخواست خط، به مخابرات ارسال کنید."
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "بررسی و تأیید مخابرات",
          "text": "مدارک توسط مخابرات بررسی و تأیید می‌شود."
        },
        {
          "@type": "HowToStep",
          "position": 4,
          "name": "تحویل و فعال‌سازی",
          "text": "خط فعال شده و آماده استفاده تحویل داده می‌شود."
        }
      ]
    }
  ]
}